import { get } from 'lodash';
import PropTypes from 'prop-types';
import { useState, useCallback } from 'react';

import { getDateLabelText } from '@hivebrite/utils';

import DateTimePicker from 'hb-react/shared/components/DateTimePicker';
import ThemeProvider from 'hb-react/style/ThemeProvider';

const InputDateRange = ({
  attrId,
  name,
  displayName,
  tooltip = '',
  onChange = null,
}) => {
  const inputId = `icad_${attrId}`;
  const [minimalMaxDate, setMinimalMaxDate] = useState();
  const handleMinDateChange = useCallback((date) => {
    setMinimalMaxDate(date);
    if (onChange) {
      onChange(date);
    }
  }, []);

  return (
    <ThemeProvider
      theme="fo"
      options={{
        customNetworkColors: get(
          window,
          'AlumniConnect.currentNetwork.colors',
          {},
        ),
      }}
    >
      <div className="push-quarter--bottom">
        <label className="color-gray" htmlFor={inputId}>
          {getDateLabelText(displayName)}
        </label>
        <div className="grid">
          <div
            className="grid__item one-half"
            title={tooltip}
            data-toggle="tooltip"
          >
            <DateTimePicker
              id={inputId}
              displayFormat={I18n.t('date.formats.alt_format')}
              locale={I18n.locale}
              name={`query[min_${name}]`}
              placeholder={__('Min')}
              onChange={handleMinDateChange}
            />
          </div>
          <div
            className="grid__item one-half"
            title={tooltip}
            data-toggle="tooltip"
          >
            <DateTimePicker
              displayFormat={I18n.t('date.formats.alt_format')}
              locale={I18n.locale}
              name={`query[max_${name}]`}
              placeholder={__('Max')}
              minDate={minimalMaxDate}
              onChange={onChange}
            />
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
};

InputDateRange.propTypes = {
  attrId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  name: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  tooltip: PropTypes.string,
  onChange: PropTypes.func,
};

export default InputDateRange;
